// utils
import * as methods from '@utils/methods';

import { DELETE, GET, POST, PUT } from '../request';

/**
 * fetch pelvis list
 * @param {*} payload
 */
export async function fetchPelvisList(payload) {
  const params = methods.convertQueryString(payload);
  return GET(`pelvis?${params}`);
}

/**
 * get pelvis
 * @param {*} payload
 */

export async function fetchPelvis(payload) {
  return GET(`pelvis/${payload}`);
}

/**
 * update pelvis by id
 * @param {*} payload
 */
export async function updatePelvisById(payload) {
  const { id, ...rest } = payload;
  return PUT(`pelvis/${id}`, rest);
}

/**
 * remove pelvis by id
 * @param {*} payload
 */
export async function removePelvisById(payload) {
  return DELETE(`pelvis/${payload}`);
}

/**
 * create pelvis
 * @param {*} payload
 */
export async function createPelvis(payload) {
  return POST(`pelvis`, payload);
}
